export default "__VITE_PUBLIC_ASSET__eaaccd57__"